import { useQuery } from '@tanstack/react-query';
import { fetchData } from '../../../utils';
import useSmartlook from '../../useSmartlook';

export function useConstraintsQuery(enabled = true) {
  const { error } = useSmartlook();
  return useQuery<Constraints>({
    queryKey: ['constraints'],
    queryFn: async () => {
      try {
        const data = await fetchData('/application/constraints');

        return data as Constraints;
      } catch (e) {
        error('[useConstraintsQuery][GET /application/constraints]', e);
        throw e;
      }
    },
    enabled,
    staleTime: Infinity,
    placeholderData: (previousData) => previousData,
  });
}

export type Constraints = {
  loanLimits: {
    1: number;
    2: number;
  };
  amountInterval: {
    min: number;
    max: number;
    step: number;
    defaultValue: number;
  };
  termInterval: {
    min: number;
    max: number;
    step: number;
    defaultValue: number;
  };
  termLimits?: Array<{
    amountFrom?: number;
    amountTo?: number;
    termFrom?: number;
    termTo?: number;
    limitType?: 'IL' | 'SPL';
  }>;
  _links?: {
    self: {
      href: string;
      title: string;
    };
  };
};
